function inserted( el, binding ){
    const callback = binding.value
    const options = binding.options || { passive: true}
    window,addEventListener('mousemove', callback, options )
    
    el._onMousemove = {
        callback,
        options
    }

}

function unbind(el) {
    const { callback, options } = el._onMousemove

    window.removeEventListener('mousemove', callback, options)
    delete el._onMousemove
}

export default {
    name: 'mousemove',
    inserted,
    unbind
}